import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/explorer/first-controlled-internal-transaction/page.tsx");
